import { Avatar, Card, Tag } from "antd";
import "../../utils/demande.css";
import { motion } from "framer-motion";
import { formatState, getStateColor } from "../../../../Components/Common/FormatDate/formatStatus";

const TechnicienDemande = ({ technicien }) => {
    
    return (
        <div className="TD-container">

            {technicien ? (

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4 }}
                >
                    <div className="TD-avatar-wrapper">
                        <Avatar
                            size={80}
                            src={technicien?.fileName}
                            style={{ backgroundColor: "#1677ff", fontSize: 40,}}
                        >
                            {technicien?.name?.charAt(0)}
                        </Avatar>

                        <h4 className="TD-name">{technicien?.name}</h4>

                        <Tag color={getStateColor(technicien?.status)} style={{ fontSize: 13 }}>
                            {formatState(technicien?.status)}
                        </Tag>
                    </div>

                    <Card className="TD-info-card">
                        <table className="TD-table">
                            <tbody>

                                <tr>
                                    <td><strong>Téléphone</strong></td>
                                    <td>{technicien?.phone || "-"}</td>
                                </tr>

                                <tr>
                                    <td><strong>Email</strong></td>
                                    <td>{technicien?.email || "-"}</td>
                                </tr>

                                <tr>
                                    <td><strong>Adresse</strong></td>
                                    <td>{technicien?.address || "Non renseignée"}</td>
                                </tr>

                                <tr>
                                    <td><strong>Actuel Véhicule</strong></td>
                                    <td>{technicien?.vehicle  ? `${technicien.vehicle.brand} ${technicien.vehicle.registrationNumber}` : "Indisponible"}</td>
                                </tr>
                            </tbody>
                        </table>
                    </Card>
                </motion.div>

            ) : (
                <p className="TD-info-card">Aucun technicien trouvé.</p>
            )}

        </div>
    );
};

export default TechnicienDemande;
